var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScoringIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5215",
    "data-name": "Group 5215",
    transform: "translate(20734 12891)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun-score-6454342",
    transform: "translate(-20724.34 -12889.014)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13137",
    "data-name": "Path 13137",
    d: "M40.239,4.864H33.308A1.262,1.262,0,0,0,32.058,3.5H23.491a1.262,1.262,0,0,0-1.249,1.364H15.31a1.874,1.874,0,0,0-1.874,1.869V45.658a1.874,1.874,0,0,0,1.874,1.869H40.239a1.874,1.874,0,0,0,1.874-1.869V6.733a1.874,1.874,0,0,0-1.874-1.869ZM22.533,8.588a1.242,1.242,0,0,0,.957.457h8.568a1.242,1.242,0,0,0,.958-.457h5.362V43.8H17.171V8.588h5.362ZM23.4,4.749a.091.091,0,0,1,.091-.091h8.568a.091.091,0,0,1,.091.091V7.8a.091.091,0,0,1-.091.091H23.491A.091.091,0,0,1,23.4,7.8ZM40.955,45.658a.714.714,0,0,1-.716.71H15.31a.714.714,0,0,1-.716-.71V6.733a.714.714,0,0,1,.716-.71h6.932V7.429h-5.65a.579.579,0,0,0-.579.579V44.382a.579.579,0,0,0,.579.579H38.958a.579.579,0,0,0,.579-.579V8.008a.579.579,0,0,0-.579-.579h-5.65V6.022h6.931a.714.714,0,0,1,.716.71Z",
    transform: "translate(-13.436 -3.5)",
    fill: "#212a42",
    stroke: "#212a42",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13138",
    "data-name": "Path 13138",
    d: "M21.056,39.133H37.7a.579.579,0,0,0,.579-.579v-24.8a.579.579,0,0,0-.579-.579H21.056a.579.579,0,0,0-.579.579v24.8A.579.579,0,0,0,21.056,39.133ZM25,27.362V24.944H37.119v2.417ZM37.119,28.52v2.417H25V28.52ZM25,23.786V21.368H37.119v2.418Zm-1.159,0H21.636V21.368h2.209Zm0,1.159v2.417H21.636V24.944Zm0,3.576v2.417H21.636V28.52Zm0,3.576v2.418H21.636V32.1ZM25,32.1H37.119v2.418H25ZM37.119,20.209H25V17.792H37.119Zm-13.275,0H21.636V17.792h2.209ZM21.636,35.673h2.209v2.3H21.636ZM25,37.975v-2.3H37.119v2.3ZM37.119,16.633H25v-2.3H37.119Zm-13.275-2.3v2.3H21.636v-2.3Z",
    transform: "translate(-15.038 -5.702)",
    fill: "#212a42",
    stroke: "#212a42",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13139",
    "data-name": "Path 13139",
    d: "M40.781,51.586H34.588a.579.579,0,0,0,0,1.159h6.193A.579.579,0,0,0,40.781,51.586Z",
    transform: "translate(-18.121 -14.445)",
    fill: "#212a42",
    stroke: "#212a42",
    strokeWidth: 0.25
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1632",
    "data-name": "Rectangle 1632",
    width: 48,
    height: 48,
    transform: "translate(-20734 -12891)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScoringIcon);
export default __webpack_public_path__ + "static/media/ScoringIcon.38c7c9fc07e5ca5fddea59a82a76ccc7.svg";
export { ForwardRef as ReactComponent };